export default __webpack_public_path__ + "static/workout-with-a-view-hero-image-3c4b2c6c544da0582f0493533bc05bd1.jpg";